const oc = {
  chiefPatrons: [
    {
      name: "Dr. B. S. Ragini Narayan",
      designation: "Donor Trustee and Member Secretary",
      workplace: "B.M.S. Educational Trust",
      photo: "/assets/photos/patrons/ragini_narayan.webp",
    },
    {
      name: "Dr. P. Dayananda Pai",
      designation: "Chairman, B.M.S. College of Engineering",
      workplace: "Life Trustee, B.M.S. Educational Trust",
      photo: "/assets/photos/patrons/dayananda.webp",
    },
    {
      name: "Dr. Karisiddappa",
      designation: "Vice Chancellor",
      workplace: "Visvesvaraya Technological University",
      photo: "/assets/photos/patrons/karisiddappa.webp",
    },
  ],
  firstPatrons: [
    {
      name: "Sri Aviram Sharma",
      role: "Trustee",
      workplace: "B.M.S. Educational Trust",
      photo: "/assets/photos/patrons/aviram_sharma.webp",
    },
    {
      name: "Sri Ravi Venkatesam",
      role: "Trustee",
      workplace: "B.M.S. Educational Trust",
      photo: "/assets/photos/patrons/ravi_venkatesam.webp",
    },
    {
      name: "Gautham V. Kalathur",
      role: "CTO, B.M.S. Educational Trust",
      workplace: "Chairman, B.M.S. Hospital Trust",
      photo: "/assets/photos/patrons/gautham_k.webp",
    },
  ],
  secondPatrons: [
    {
      name: "Dr. A. S. Deshpande",
      role: "Registrar",
      workplace: "VTU",
      photo: "/assets/photos/patrons/asdeshpande.webp",
    },
    {
      name: "Dr. B. E. Rangaswamy",
      role: "Registrar (Evaluation)",
      workplace: "VTU",
      photo: "/assets/photos/patrons/berangaswamy.webp",
    },
    {
      name: "Smt. M. A. Sapna",
      role: "Finance Officer",
      workplace: "VTU",
      photo: "/assets/photos/patrons/masapna.webp",
    },
    {
      name: "Dr. A. G. Bujurke ",
      role: "Director of Physical Education",
      workplace: "VTU",
      photo: "/assets/photos/patrons/agbujurke.webp",
    },
  ],
  thirdPatrons: [
    {
      name: "Dr. S. Muralidhara",
      designation: "Chairman",
      role: "Principal",
      workplace: "B.M.S. College of Engineering",
      photo: "/assets/photos/patrons/muralidhara.webp",
    },
  ],
  fourthPatrons: [
    {
      name: "Dr. Suresh Ramaswwamyreddy",
      designation: "Vice Chairman",
      role: "Vice Principal (Admin)",
      workplace: "B.M.S. College of Engineering",
      photo: "/assets/photos/patrons/sureshrr.webp",
    },
    {
      name: "Dr. Bheemsha Arya",
      designation: "Vice Chairman",
      role: "Vice Principal (Academic)",
      workplace: "B.M.S. College of Engineering",
      photo: "/assets/photos/patrons/bheemsha.webp",
    },
    {
      name: "Dr. Ratanraj K J",
      designation: "Vice Chairman",
      role: "Dean (Student Affairs)",
      workplace: "B.M.S. College of Engineering",
      photo: "/assets/photos/patrons/rathanraj.webp",
    },
  ],
  fifthPatrons: [
    {
      name: "Dr. Shivarama Reddy M.",
      designation: "Organising Secretary",
      role: "Director of Physical Education",
      workplace: "B.M.S. College of Engineering",
      photo: "/assets/photos/patrons/shivaramreddy.webp",
    },
    {
      name: "Dr. Prathima Bhat K.",
      designation: "Treasurer",
      role: "Cultural Coordinator",
      workplace: "B.M.S. College of Engineering",
      photo: "/assets/photos/patrons/pratima.webp",
    },
  ],
  developers: [
    {
      name: "Parjanya Modi",
      designation: "Coordinator",
      role: "Full Stack Developer",
      photo: "https://parjanyamodi.com/assets/images/IMG_0943.webp",
      link: "https://parjanyamodi.com",
    },
    {
      name: "Vijayeshjeevan Matam",
      designation: "Member",
      role: "Backend Developer",
      photo: "https://parjanyamodi.com/assets/images/IMG_0943.webp",
    },
    {
      name: "Khushil Sindhwad",
      designation: "Member",
      role: "Full Stack Developer",
      photo: "https://parjanyamodi.com/assets/images/IMG_0943.webp",
    },
    {
      name: "Prajwal",
      designation: "Designer",
      role: "Frontend Designer",
      photo: "https://parjanyamodi.com/assets/images/IMG_0943.webp",
    },
  ],
  "design team": [
    {
      name: "Parjanya Modi",
      designation: "Coordinator",
      role: "Full Stack Developer",
      photo: "https://parjanyamodi.com/assets/images/IMG_0943.webp",
    },
    {
      name: "Vijayeshjeevan Matam",
      designation: "Member",
      role: "Backend Developer",
      photo: "https://parjanyamodi.com/assets/images/IMG_0943.webp",
    },
    {
      name: "Khushil Sindhwad",
      designation: "Member",
      role: "Full Stack Developer",
      photo: "https://parjanyamodi.com/assets/images/IMG_0943.webp",
    },
  ],
};

export default oc;
